export enum LogMessageAction {
  SystemException = 'System exception in',
  CaseRejected = 'Case is rejected',
  CaseApproved = 'Case is approved',
  CaseReseted = 'Case is reset',
  CaseSaved = 'Case is saved',
  CaseClosed = 'Case is closed',
  CaseDownload = "Case log is downloaded",
  CaseEdited= "Case is edited",
}
